var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:{'tab-title': true, 'active': _vm.active},on:{"click":function($event){$event.preventDefault();return _vm.activate($event)}}},[_c('a',{attrs:{"id":_vm.idValue,"aria-selected":_vm.active,"href":_vm.hrefValue,"aria-controls":_vm.ariaControls,"tabindex":"0"}},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0376b630","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabs/TabButton.vue
// module id = 3DBN
// module chunks = 1